import { stripLocalePrefix } from '../routes/publicPaths';

export const NAV_ITEMS_CACHE_KEY = 'khayr_public_nav_v6';

const LEGACY_PROGRAM_SLUGS = {
  imaar: 'ramadan',
  ihyaa: 'adahi',
};

/** Never keep a renamed programme's old slug in the public URL. */
export const resolveProgramNavSlug = (label, slug) => {
  const name = String(label || '');
  if (name.includes('مائدة')) {
    return 'ramadan';
  }
  if (name.includes('أضحية') || name.includes('إحياء')) {
    return 'adahi';
  }
  return LEGACY_PROGRAM_SLUGS[slug] || slug;
};

export const resolveProgramNavPath = (label, path) => {
  const name = String(label || '');
  if (name.includes('مائدة')) {
    return '/programmes/ramadan';
  }
  if (name.includes('أضحية') || name.includes('إحياء')) {
    return '/programmes/adahi';
  }
  if (!path) return path;
  return stripLocalePrefix(String(path))
    .replace(/\/programmes\/imaar(?=\/|$)/, '/programmes/ramadan')
    .replace(/\/programmes\/ihyaa(?=\/|$)/, '/programmes/adahi');
};

const normalizeNavItem = (item) => {
  if (!item) return item;
  let next = item;
  if (item.megaMenu || item.slug) {
    next = { ...next, slug: resolveProgramNavSlug(item.name, item.slug) };
  }
  if (item.path) {
    next = { ...next, path: resolveProgramNavPath(item.name, item.path) };
  }
  if (item.children) {
    next = { ...next, children: item.children.map(normalizeNavItem) };
  }
  return next;
};

export const normalizeNavItems = (items) =>
  (Array.isArray(items) ? items : []).map(normalizeNavItem);

export const DEFAULT_NAV_ITEMS = [
  { name: 'الرئيسية', path: '/' },
  { name: 'سقيا', slug: 'saqya', megaMenu: true },
  { name: 'أيتامنا', slug: 'kafala', megaMenu: true },
  { name: 'عمرة', slug: 'omra', megaMenu: true },
  { name: 'مائدة الرحمن', slug: 'ramadan', megaMenu: true },
  { name: 'قوافل تضامنية', path: '/programmes/caravane' },
  {
    name: 'مشاريع أخرى',
    children: [
      { name: 'أضحية العيد', path: '/programmes/adahi' },
      { name: 'كسوة العيد', path: '/programmes/namaa' },
      { name: 'إغاثة', path: '/programmes/ighatha' },
      { name: 'كل البرامج', path: '/programmes' },
    ],
  },
  {
    name: 'عن صحبة الخير',
    children: [
      { name: 'من نحن', path: '/about' },
      { name: 'إحصائيات', path: '/stats' },
    ],
  },
];

export const readNavItemsCache = () => {
  try {
    const raw = localStorage.getItem(NAV_ITEMS_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? normalizeNavItems(parsed) : null;
  } catch {
    return null;
  }
};

export const writeNavItemsCache = (items) => {
  try {
    localStorage.setItem(NAV_ITEMS_CACHE_KEY, JSON.stringify(items));
  } catch {
    // ignore quota errors
  }
};

export const mapNavItemsFromApi = (items) =>
  normalizeNavItems(
    items
      .map((item) => {
        if (item.type === 'link') {
          return { id: item.id, name: item.label, path: item.path };
        }
        if (item.type === 'program_mega') {
          return {
            id: item.id,
            name: item.label,
            slug: resolveProgramNavSlug(item.label, item.program_slug),
            megaMenu: true,
          };
        }
        if (item.type === 'dropdown') {
          return {
            id: item.id,
            name: item.label,
            children: (item.children || []).map((child) => ({
              id: child.id,
              name: child.label,
              path: resolveProgramNavPath(child.label, child.path),
            })),
          };
        }
        return null;
      })
      .filter(Boolean)
  );
